var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStick24Filled = function SvgIconStick24Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.363 14.846V10.27h1.275v4.575H8.363Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.919 8.126V3.329h4.163v4.797l1.503 2.145h-7.17L6.92 8.126Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.281 3.33c0-.353.286-.638.638-.638h4.163c.351 0 .637.285.637.637v4.595l1.388 1.98a.638.638 0 0 1-.522 1.004h-7.17a.638.638 0 0 1-.522-1.003l1.388-1.98V3.328Zm1.275.637v4.159c0 .13-.04.258-.115.366l-.8 1.141h4.719l-.8-1.141a.637.637 0 0 1-.116-.366v-4.16H7.556Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.585 3.967h-7.17V2.692h7.17v1.275Z",
    fill: "current"
  })));
};
export default SvgIconStick24Filled;